import React from 'react';
import styled from 'styled-components';
import CaseStudySection from '@components/shared/CaseStudySection';
import VMSFoundersResults from '@components/shared/VMSFoundersResults';
import { ArticleSliceType } from '@contracts';

export interface Props {
  articleBody: any[];
}

export default function ExtraArticleContentItems({ articleBody }: Props) {
  if (!articleBody) return null;

  const renderItems = (articleItem: any, index: number) => {
    switch (articleItem.slice_type) {
      case ArticleSliceType.CaseStudies: {
        return (
          <CaseStudySectionContainer key={`article-extra-content-${index}`}>
            <CaseStudySection slice={articleItem} className="case-studies" vitalsFonts={true} />
          </CaseStudySectionContainer>
        );
      }
      case ArticleSliceType.VMSFoundersResults: {
        return (
          <FullWidthContainer key={`article-extra-content-${index}`}>
            <VMSFoundersResults />
          </FullWidthContainer>
        );
      }
      default:
        return null;
    }
  };

  return articleBody.map((item, index) => renderItems(item, index));
}

const FullWidthContainer = styled.div`
  width: 100vw;
`;

const CaseStudySectionContainer = styled.div`
  width: 100vw;
  text-align: start;
`;
